// extracted by mini-css-extract-plugin
module.exports = {"management_header_logo":"Header_management_header_logo__1hN7g","management_info_img":"Header_management_info_img__JHk45"};